import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function CalendlyEmbed() {
    return (
        <section className="bg-[#F8F9FA] py-24 md:py-32" data-testid="calendly-section">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-10">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-3">
                        Book Your Diagnostic Call with Adam.
                    </h2>
                    <p className="text-[#6B7280] text-lg">
                        Pick a time that works. 30 minutes. No obligation.
                    </p>
                </motion.div>
                <motion.div
                    {...fadeUp}
                    className="rounded-sm overflow-hidden border border-gray-200 shadow-sm bg-white"
                    data-testid="calendly-embed"
                >
                    <iframe
                        src="https://calendly.com/adam-whiteglovehiring/wgh-va-consultation"
                        width="100%"
                        height="650"
                        frameBorder="0"
                        title="Book a Diagnostic Call with Adam"
                    />
                </motion.div>
                <motion.p {...fadeUp} className="text-[#6B7280] text-xs leading-relaxed mt-5" data-testid="sms-consent-text">
                    By booking a call and providing your phone number, you agree to receive calls and text messages from White Glove Hiring about your scheduled call and our services. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. Consent is not a condition of purchase. See our <Link to="/privacy-policy" className="text-navy-900 font-semibold underline underline-offset-2 hover:text-gold-500 transition-colors" data-testid="consent-privacy-link">Privacy Policy</Link> and <Link to="/terms-of-service" className="text-navy-900 font-semibold underline underline-offset-2 hover:text-gold-500 transition-colors" data-testid="consent-terms-link">Terms of Service</Link>.
                </motion.p>
            </div>
        </section>
    );
}
